import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  const lang =  localStorage.getItem('current_lang')||'ar';
  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: '/'+lang+"/login", state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
   {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
